import {Layout} from 'components/layout';
import {apartmentsList as thirdList, apartmentsFirstSecondList, apartmentsList} from 'lib/apartments/apartments-data';
import {cn} from 'lib/utils';
import {useMemo, useState, useEffect} from 'react';
import {ApartmentsFinishingItem} from '../apartments-finishing-item/apartments-finishing-item';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '../carousel/carousel';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../dialog/dialog';
import {Button} from '../primitives/button/button';
import {Checkbox} from '../primitives/checkbox/checkbox';
import {Input} from '../primitives/imput/input';
import {IMaskInput} from "react-imask";
import {useSendForm} from "../../../lib/hooks/use-send-form";

import {useConsentStore} from "../../../lib/store/consent-store";

export interface Apartment {
  image: string;
  title: string;
  price: string;
  commonSpace: string;
  livingSpace: string;
  dialogTitle: string;
  priceNumber?: number;
  oldPrice?: string;
  oldPriceNumber?: number;
  firstText?: string;
  secondText?: string; 
}

  const flatGroupList = [
    {value: 'first-second', label: '1, 2 корпус'},
    {value: 'third', label: '3 корпус'},
  ];

export const ApartmentsFinishing = () => {
  const [selectedTab, setSelectedTab] = useState({
    value: 'all',
    label: 'Все',
  });
  const [selectedApartment, setSelectedApartment] = useState<Apartment | null>(
    null
  );
  const [selectedGroup, setSelectedGroup] = useState<string>("first-second");

  const apartmentsList = (selectedGroup === "first-second" ? apartmentsFirstSecondList : thirdList) as Apartment[];

  const [isOpen, setIsOpen] = useState(false);

  const consent = useConsentStore(state => state.consent);
  const updateConsent = useConsentStore(state => state.updateConsent);

  const [termsChecked, setTermsChecked] = useState(false);
  const [termsError, setTermsError] = useState(false)
  const [fieldsError, setFieldsError] = useState(false)

  const [success, setSuccess] = useState(false);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    text: selectedApartment?.title
  })

  useEffect(() => {
    setFieldsError(false)
  }, [formData])

  useEffect(() => {
    setTermsError(false)
  }, [termsChecked]);

  useEffect(() => {
    if (selectedApartment !== null) {
      setFormData({...formData, text: selectedApartment?.title});
    }
    setSuccess(false)
  }, [selectedApartment]);

  const handleInputChange = (value: string, name: string) => {
    setFormData({...formData, [name]: value})
  }

  const validateFormAndSend = () => {
    if (formData.name === '' || formData.phone === '') {
      setFieldsError(true)
      return
    }

    if (!termsChecked) {
      setTermsError(true)
      return
    }

    sendForm(formData, 'getFlatPrice2', () => {
      setSuccess(true)
    })
  }

  const {sendForm, isPending, error} = useSendForm()


  const handleApartmentClick = (item: Apartment) => {
    setSelectedApartment(item);
    setIsOpen(true);
  };

  const getAreaValue = (value: string) => {
    const numeric = value.replace(',', '.').replace(/[^\d.]/g, '');
    return parseFloat(numeric) || 0;
  };

  const sortByArea = (list: Apartment[]) =>
    [...list].sort(
      (first, second) =>
        getAreaValue(first.commonSpace) - getAreaValue(second.commonSpace)
    );

  const memoizedApartments = useMemo(() => {
    if (selectedTab.value === 'studio') {
      return sortByArea(
        apartmentsList.filter((item) => item.title.includes('Студия'))
      );
    }

    if (selectedTab.value === '1-room') {
      return sortByArea(
        apartmentsList.filter(
          (item) =>
            item.title.includes('1-комнатная') && !item.title.includes('Студия')
        )
      );
    }

    if (selectedTab.value === '2-room') {
      return sortByArea(
        apartmentsList.filter(
          (item) =>
            item.title.includes('2-комнатная') && !item.title.includes('Студия')
        )
      );
    }

    if (selectedTab.value === '3-room') {
      return sortByArea(
        apartmentsList.filter(
          (item) =>
            item.title.includes('3-комнатная') && !item.title.includes('Студия')
        )
      );
    }

    return sortByArea(apartmentsList);
  }, [selectedTab, selectedGroup]);

  const tabsList = [
    {value: 'all', label: 'Все'},
    {value: 'studio', label: 'Студии'},
    {value: '1-room', label: '1-комнатные'},
    {value: '2-room', label: '2-комнатные'},
    {value: '3-room', label: '3-комнатные'},
  ];

  return (
    <section
      id='flats'
      className="bg-plt-secondary/50 pt-[72px] pb-[50px] font-open-sans screen-1150:bg-plt-white screen-1150:pt-5">
      <Layout.Container>
        <div className="bg-plt-white rounded-[40px] pt-10 pb-[52px] screen-1150:py-0">
          <h3 className="uppercase font-bold text-center text-[32px] text-plt-black screen-700:text-lg">
            ПОСМОТРИТЕ ПЛАНИРОВКИ И УЗНАЙТЕ ПОДРОБНЕЕ
          </h3>
          <div className="mx-auto w-fit flex items-center gap-5 mt-[26px] screen-1100:flex-wrap screen-1100:justify-center">
            <div className="flex gap-3 justify-center screen-1100:w-full">
              {flatGroupList.map((m, index) => (
                <button
                  key={index.toString() + m.value}
                  onClick={() => {
                    if (m.value !== selectedGroup) {
                      setSelectedGroup(m.value)
                    }
                  }}
                  className={cn(
                    'text-plt-black font-semibold px-[15px] py-1.5 bg-[#B4B4B4] rounded-md',
                    m.value === selectedGroup &&
                    'bg-plt-black text-plt-white'
                  )}
                >
                  <span className="">{m.label}</span>
                </button>
              ))}
            </div>
            {tabsList.map((tab, index) => (
              <button
                key={index.toString() + tab.value}
                onClick={() => setSelectedTab(tab)}
                className={cn(
                  'text-plt-black font-semibold px-[15px] py-1.5 bg-[#B4B4B4] rounded-full',
                  tab.value === selectedTab.value &&
                  'bg-plt-black text-plt-white'
                )}
              >
                <span className="screen-600:hidden">{tab.label}</span>
                <span className="hidden screen-600:block">
                  {tab.label.length > 4 && tab.label.charAt(0)}
                  {tab.label === 'Все' && tab.label}
                </span>
              </button>
            ))}
          </div>
          {/* <div className={cn("mt-[36px] grid grid-cols-5 gap-4 px-[33px]", selectedGroup !== "first-second" ? "screen-1150:hidden" : "hidden")}>
            {memoizedApartments?.map((apartment, index) => {
              if (index < 5) {
                return (
                  <ApartmentsFinishingItem
                    key={index.toString() + apartment.title}
                    apartment={apartment}
                    handleApartmentClick={handleApartmentClick}
                  />
                );
              }
              return null;
            })}
          </div> */}
          <div className={cn("px-[66px] mt-4", true ? "": "hidden screen-1150:block")}>
            <Carousel opts={{align: 'start'}}>
              <CarouselContent className="w-full">
                {memoizedApartments?.map((apartment, index) => (
                  <CarouselItem
                    key={index.toString() + apartment.title}
                    className="basis-1/4 screen-950:basis-1/3 screen-750:basis-1/2 screen-550:basis-full"
                  >
                    <ApartmentsFinishingItem
                      apartment={apartment}
                      handleApartmentClick={handleApartmentClick}
                    />
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious className="border-plt-secondary"/>
              <CarouselNext className="border-plt-secondary"/>
            </Carousel>
          </div>
          <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogContent className="bg-[#FAFAFC] border-none w-[670px] max-h-full screen-500:w-screen screen-500:overflow-y-scroll">
              <DialogHeader>
                <DialogTitle className="text-center text-4xl">
                  {selectedApartment?.dialogTitle}
                </DialogTitle>
                <DialogDescription className="hidden"></DialogDescription>
              </DialogHeader>
              <div className="flex justify-between mt-5 screen-600:flex-col-reverse screen-600:items-center">
                <div className=' shrink-0 screen-500:shrink flex-col flex justify-between basis-1/2'>
                  <div>
                    <p className='text-xl'>
                      Общая площадь:{' '}
                      <span className="font-bold">{selectedApartment?.commonSpace}</span>
                    </p>
                    <p className='text-xl'>
                      Жилая площадь:{' '}
                      <span className="font-bold">{selectedApartment?.livingSpace}</span>
                    </p>
                  </div>
                  <div className='flex flex-wrap'>
                    {selectedApartment?.priceNumber && selectedApartment?.oldPriceNumber && (
                      <div className='w-full text-center my-3'>
                        <p className='text-xl'>
                          {selectedApartment?.priceNumber?.toLocaleString('ru-RU')} руб
                        </p>
                        <p className='text-xl line-through'>
                          {selectedApartment?.oldPriceNumber?.toLocaleString('ru-RU')} руб
                        </p>
                      </div>
                    )}
                    <div className='w-full flex items-stretch gap-3'>
                      {selectedApartment?.firstText && (<div className='font-bold text-white bg-plt-secondary rounded px-5 py-3 grow text-center'>{selectedApartment.firstText}</div>)}
                      {selectedApartment?.secondText && (<div className='font-bold text-white bg-plt-secondary rounded px-5 py-3 grow text-center'>{selectedApartment.secondText}</div>)}
                    </div>
                  </div>
                </div>
                <div className="max-w-[266px] max-h-[262px] w-full h-full">
                  <img
                    src={selectedApartment?.image}
                    alt={selectedApartment?.title}
                    className="max-w-[266px] max-h-[262px] w-full h-full object-scale-down"
                  />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-1 mt-5 screen-600:grid-cols-1">
                <Input
                  value={formData.name}
                  onChange={e => handleInputChange(e.target.value, 'name')}
                  placeholder="Ваше имя"/>
                <IMaskInput
                  value={formData.phone}
                  onAccept={value => handleInputChange(value, 'phone')}
                  mask={'+7 (000) 000-00-00'}
                  placeholder={'Ваш телефон'}
                  className={cn(
                    'ym-record-keys placeholder:text-plt-dark-gray selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-plt-gray flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
                    'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
                    'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                    'rounded-[5px]'
                  )}/>
                <Button disabled={isPending} onClick={validateFormAndSend} className="font-bold">Узнать
                  подробнее</Button>
              </div>
              <div>
                {termsError &&
                    <p className='text-xs text-red-500'>Пожалуйста, дайте согласие на обработку персональных данных</p>}
                {fieldsError && <p className='text-xs text-red-500'>Пожалуйста, заполните все поля перед отправкой</p>}
              </div>
              {success &&
                  <p className='py-3 rounded text-center text-xs text-green-500 border border-solid border-green-500'>Форма
                    успешно
                    отправлена, спасибо!</p>}
              <div className="flex items-center gap-2">
                <Checkbox
                  checked={termsChecked}
                  onCheckedChange={checked => setTermsChecked(checked === true)}
                  id="apartment-terms"
                  className="border-[#D3D3D3] rounded-[1px]"
                />
                <label
                  htmlFor="apartment-terms"
                  className="tracking-[-3%] text-[#989898]"
                >
                  Нажимая кнопку «Узнать подробнее», вы даете согласие на
                  обработку персональных данных и соглашаетесь с политикой
                  конфиденциальности
                </label>
              </div>
              <div className="flex items-center gap-2">
                <Checkbox id='cookies' checked={consent} onCheckedChange={(checked) => updateConsent(checked === true)}
                          className="rounded-[1px] border-[#D3D3D3] shrink-0"/>
                <label htmlFor='cookies' className="text-[#989898]">
                  Я ознакомлен (-на) с правилами обработки куки
                </label>
              </div>
            </DialogContent>
          </Dialog>
        </div>
      </Layout.Container>
    </section>
  );
};
